import 'photoswipe/style.css';

import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default function initMosaicGallery(galleryData, extraOptions = {}) {
  return new PhotoSwipeLightbox({
    dataSource: galleryData,
    allowUserZoom: false,
    bgOpacity: 1,
    spacing: 0.1,
    trapFocus: false,
    returnFocus: false,
    preloaderDelay: 200,
    preloadFirstSlide: true,
    zoom: false,
    clickToCloseNonZoomable: false,
    imageClickAction: 'next',
    pswpModule: PhotoSwipe,
    escKey: false,
    arrowPrevSVG: '',
    arrowNextSVG: '',
    closeSVG: '',
    showHideAnimationType: 'none',
    tapAction: () => { },
    paddingFn: (viewportSize, itemData) => {
      const isVertical = itemData.height > itemData.width;
      if (isVertical) {
        if (viewportSize.x > 767) {
          return {
            top: 64, bottom: 90, left: 75, right: 75,
          };
        }
        return {
          top: 70, bottom: 70, left: 0, right: 0,
        };
      }

      // horizontal
      if (viewportSize.x > 767) {
        return {
          top: 64, bottom: 90, left: 75, right: 75,
        };
      }
      return {
        top: 56, bottom: 68, left: 0, right: 0,
      };
    },
    ...extraOptions,
  });
}

export function addCaption(lightbox) {
  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 2,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (element) => {
        lightbox.pswp.on('change', () => {
          element.innerHTML = lightbox.pswp.currSlide.data.caption;
        });
      },
    });
  });
}

export function addCloseButton(lightbox) {
  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'close-gallery',
      order: 3,
      isButton: false,
      appendTo: 'root',
      html: '<span class="pswp__close__label">Close</span>',
      onClick: () => {
        lightbox.pswp.close();
      },
    });
  });
}

export function addBackButton(lightbox) {
  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'back',
      order: 1,
      isButton: false,
      appendTo: 'root',
      html: '<span class="pswp__back__label">Back</span>',
      onClick: () => {
        lightbox.pswp.close();
      },
    });
  });
}
